import React from 'react';
import celebrationIcon from 'assets/img/celebration-emoji.png';
import closeIcon from 'assets/svg/icon-close.svg';

type MinimumInterestResponseCardProps = {
    onCloseCardButton(): void,
}

const MinimumInterestResponseCard: React.FC<MinimumInterestResponseCardProps> = (props: MinimumInterestResponseCardProps): JSX.Element => {
    const {
        onCloseCardButton
    } = props;
    return (
    <div className='minimum-interest-card'>
        <div className='minimum-interest-card-title'>
            <div>
                <span>
                    é o seu dia!
                    <img src={celebrationIcon} />
                </span>
            </div>
                <button className='close-card-btn' onClick={onCloseCardButton}>
                    <img src={closeIcon} />
                </button>
        </div>

        <p>você atingiu a menor taxa de<br />juros possível da biz</p>
    </div>
    )
}

export default MinimumInterestResponseCard;
